import { Box, Button, DialogActions } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface IDialogButtonsBoxProps {
  children: React.ReactNode;
}

export const DialogButtonsBox = (props: IDialogButtonsBoxProps) => {
  const { children } = props;
  return (
    <>
      <Box mt={1} display="flex" flexDirection="column"></Box>
      <DialogActions data-cy="dialog-actions">{children}</DialogActions>
    </>
  );
};

interface IDialogButtonsProps {
  isSubmitting?: boolean;
  submitButtonLabel?: string;
  submitCallback?: () => void;
  resetButtonLabel?: string;
  resetCallback?: () => void;
  children?: React.ReactNode;
}

const DialogButtons = (props: IDialogButtonsProps) => {
  const {
    isSubmitting,
    submitButtonLabel,
    submitCallback,
    resetButtonLabel,
    resetCallback,
    children,
  } = props;
  const { t } = useTranslation();
  return (
    <>
      <DialogButtonsBox>
        {children}
        <Button
          type="reset"
          disabled={isSubmitting || false}
          onClick={resetCallback}
        >
          {t(resetButtonLabel || "Cancel")}
        </Button>
        {submitCallback ? (
          <Button onClick={submitCallback}>
            {t(submitButtonLabel || "Ok")}
          </Button>
        ) : (
          <Button type="submit" disabled={isSubmitting || false}>
            {t(submitButtonLabel || "Ok")}
          </Button>
        )}
      </DialogButtonsBox>
    </>
  );
};

export default DialogButtons;
